<script setup lang="ts">
import { ref, onMounted } from 'vue';
import type { ElScrollbar } from 'element-plus/es/components/scrollbar';

defineExpose({
  name: 'ScrollBox',
});

const emit = defineEmits(['scroll']);

const scrollBoxRef = ref<InstanceType<typeof ElScrollbar>>();

onMounted(() => {
  const scrollContent = scrollBoxRef.value?.wrapRef;

  scrollContent?.setAttribute('tabindex', '0');

  if (scrollContent) {
    scrollContent.addEventListener('scroll', () => {
      const scrollHeight = scrollContent.scrollHeight;
      const scrollTop = scrollContent.scrollTop;
      const clientHeight = scrollContent.clientHeight;
      emit('scroll', { scrollTop, scrollHeight, clientHeight });
    });
  }
});
</script>

<template>
  <el-scrollbar class="ScrollBox" ref="scrollBoxRef">
    <slot />
  </el-scrollbar>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

$border-size: $service-unit * 0.5;

.ScrollBox {
  :deep(.el-scrollbar__wrap) {
    min-width: 100%;
  }

  :deep(.el-scrollbar__view) {
    height: 100%;
  }

  :deep(.el-scrollbar__bar) {
    right: 0;
    z-index: $service-z-index-f;

    &.is-horizontal {
      height: $service-unit * 3;

      .el-scrollbar__thumb {
        background-color: $color-gray-40;
        background-clip: padding-box;
        border: $border-size solid transparent;
        border-radius: $service-unit * 4;
        opacity: 1;
      }
    }

    &.is-vertical {
      width: $service-unit * 3;

      .el-scrollbar__thumb {
        background-color: $color-gray-40;
        background-clip: padding-box;
        border: $border-size solid transparent;
        border-radius: $service-unit * 4;
        opacity: 1;
      }
    }
  }
}
</style>
